import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { formatApiError } from "@/lib/api";
import { AuthShell, Field, SubmitBtn, ErrorNote } from "./AuthShell";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // Fixed internal destination, never an arbitrary redirect supplied by a URL.
  const demoEntry = new URLSearchParams(location.search).get("next") === "demo";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(email, password);
      navigate(demoEntry ? "/demo" : data?.user?.is_platform_admin ? "/admin" : "/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      rich
      title="Connexion"
      subtitle="Accédez à votre espace de travail Lodge & Co."
      footer={
        <>
          Pas encore de compte ?{" "}
          <Link to="/register" data-testid="link-register" className="font-semibold text-[#3E7256] hover:underline">
            Créer un compte
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <ErrorNote>{error}</ErrorNote>
        <Field
          label="E-mail"
          type="email"
          data-testid="login-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="vous@organisation.com"
          required
        />
        <Field
          label="Mot de passe"
          type="password"
          data-testid="login-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />
        <div className="flex justify-end">
          <Link
            to="/forgot-password"
            data-testid="link-forgot"
            className="text-xs font-medium text-slate-500 hover:text-[#3E7256]"
          >
            Mot de passe oublié ?
          </Link>
        </div>
        <SubmitBtn loading={loading} data-testid="login-submit">
          Se connecter
        </SubmitBtn>
      </form>
    </AuthShell>
  );
}
